import { startVerification } from "app/api/documentsApi";
import { VerificationDocumentsHelper } from "app/helpers/verificationDocumentsHelper";
import type { VerificationDocumentType } from "app/types/documentType";
import { useState } from "react";
import { FormattedMessage, IntlShape } from "react-intl";
import DocumentsUploadedMessage from "../DocumentsUploadedMessage/DocumentsUploadedMessage";
import "./StartVerification.scss";

type Props = {
  documentList: VerificationDocumentType[];
  intl: IntlShape;
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

const StartVerification = (props: Props) => {
  const { documentList, intl, setIsLoading, isLoading } = props;
  const [success, setSuccess] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const handleStartVerification = async () => {
    const error =
      VerificationDocumentsHelper.verifyIdUploaded(documentList, intl) ||
      VerificationDocumentsHelper.verifyProofOfAddressUploaded(
        documentList,
        intl
      );
    setErrorMessage(error);

    if (error) {
      return;
    }
    setIsLoading(true);
    setErrorMessage("");
    setSuccess(false);
    // Message to be shown in case we don't get a message from the server
    const genericErrorMessage = intl.formatMessage({
      id: "error-contact-support",
      defaultMessage:
        "An unexpected error occurred. Please contact our customer support team on support@3et.com",
    });
    try {
      const response = await startVerification();
      if (response.status === 200) {
        setSuccess(true);
      } else if (
        response.data &&
        response.data.errors &&
        response.data.errors.length > 0
      ) {
        // Example error response
        //   {
        //     "errors": [
        //         {
        //             "messages": [
        //                 "This identity verification cannot be automatically processed. Please contact customer support for assistance. Reason: User could not be verified automatically."
        //             ]
        //         }
        //     ]
        // }
        const firstError = response.data.errors[0];
        if (firstError.messages && firstError.messages.length > 0) {
          setErrorMessage(firstError.messages[0]);
        } else {
          setErrorMessage(genericErrorMessage);
        }
      } else {
        setErrorMessage(genericErrorMessage);
      }
    } catch (error: any) {
      console.log("error: ", error);
      if (
        error.response.data &&
        error.response.data.errors &&
        error.response.data.errors.length > 0
      ) {
        const firstError = error.response.data.errors[0];
        if (firstError.messages && firstError.messages.length > 0) {
          setErrorMessage(firstError.messages[0]);
        } else {
          setErrorMessage(genericErrorMessage);
        }
      } else {
        setErrorMessage(genericErrorMessage);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="start-verification-container">
      {!success && (
        <button
          className="start-verification-container__button"
          onClick={handleStartVerification}
          disabled={isLoading}
        >
          <FormattedMessage
            id="start-verification"
            defaultMessage="Start Verification"
          />
        </button>
      )}

      {success && <DocumentsUploadedMessage />}
      {errorMessage && <div className="error-message">{errorMessage}</div>}
    </div>
  );
};

export default StartVerification;
